import axios from "axios";
let GROOVE_API_URL;
let MASTER_API_URL;

if (process.env.REACT_APP_NODE_ENV === "local") {
  GROOVE_API_URL = process.env.REACT_APP_WPQ_GROOVE_API_URL;
  MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
} else {
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "wpq";
  MASTER_API_URL = process.env.REACT_APP_API_URL + "masters";
}

export async function getallgroove(type) {
  const response = await axios
    .get(GROOVE_API_URL + `/WpqHeaderMast/${type}`)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getGridHeaderData(type, band, user, year) {
  let reqbody = { type: type, band: band, user: user, year: year };
  const response = await axios.post(GROOVE_API_URL + `/WpqHeaderMast/grid`, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getWPQGridHeaderDataAllTypes(rowdata) {
  let reqbody = {
    types: ["Groove", "Overlay", "Tubesheet"],
    ...rowdata // spread all props like WI_Welder_Id, WI_Type, etc.
  };
  const response = await axios.post(GROOVE_API_URL + `/WpqHeaderMast/alltypegrid`, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.error("Error fetching WPQ data:", error);
      return { message: "Unable to fetch WPQ data", status: false };
    });

  return response.data;
}

//used in WPQTubesheet1,get by welder id and Recordno
export const getbyrecordno = async (groove, IdprojectPK, IdprojectSK) => {
  let reqbody = { Groove: groove, WelderId: IdprojectPK, RecordNo: IdprojectSK };
  let url = `${GROOVE_API_URL}/WpqHeaderMast/getbyrecordno`;
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      console.log("error => ", error)
      return { data: [] };
    });
  return response.data || [];
};

export const deleteWPQRecord = async (deletObj) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/deletewpq`;
  const response = await axios.post(url, deletObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  return response.data;
};

export const getbyprojectnoWPQ_WI = async (
  groove,
  IdprojectPK,
  IdprojectSK
) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/getprojectnowi`;
  let reqbody = { Groove: groove, PK: IdprojectPK, SK: IdprojectSK };

  const response = await axios.post(url, reqbody)
    // .then(function (resp) {
    //   return resp;
    // })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getPresignedURLgrid = async (image) => {
  let url = `${MASTER_API_URL}/file/wpq_groove`;
  let reqbody = { image: image };
  const response = await axios.post(url, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getPresignedURLgriddelete = async (image) => {
  let url = `${MASTER_API_URL}/file/wpq_groove_delete`;
  let reqbody = { image: image };
  const response = await axios.post(url, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const AddNewGrooveWPQ = async (WPQ_Header_Master) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast`;
  const response = await axios.post(url, WPQ_Header_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
};

export const UpdateRecord = async (WPQ_Header_Master) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/update`;
  const response = await axios.post(url, WPQ_Header_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export async function getselectedwelder(Welder) {
  let url = `${GROOVE_API_URL}/wi/logic/getwelder`;
  const resp = await axios.post(url, Welder)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

export async function WQCexportreport(filters, limit = 1200, exclusiveStartKey = null) {
  try {
    const url = `${GROOVE_API_URL}/WpqHeaderMast/WQCexportreport`;
    const requestBody = { ...filters, limit, exclusiveStartKey };
    const response = await axios.post(url, requestBody);
    return response.data || { data: [], hasMore: false };
  } catch (err) {
    console.error('WQCexportreport failed:', err);
    return { data: [], hasMore: false };
  }
}

export async function WQCexportreportAll(filters) {
  try {
    let allData = [];
    const limit = 1200;
    let hasMore = true;
    let pageCount = 0;
    let exclusiveStartKey = null;

    while (hasMore) {
      pageCount++;
      console.log(`Fetching page ${pageCount}`);
      const result = await WQCexportreport(filters, limit, exclusiveStartKey);

      if (result && result.data && result.data.length > 0) {
        allData = [...allData, ...result.data];
        hasMore = result.hasMore === true;
        exclusiveStartKey = result.exclusiveStartKey;
        console.log(`Got ${result.data.length} records, total: ${allData.length}, hasMore: ${hasMore}`);
      } else {
        hasMore = false;
      }
    }

    console.log(`WQCexportreportAll completed with ${allData.length} total records`);
    return allData;
  } catch (err) {
    console.error('WQCexportreportAll failed:', err);
    return [];
  }
}

//QC chart
export async function getRequiredWPQNo(jtType) {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/WPQField/${encodeURIComponent(jtType)}`;
  const response = await axios
    .get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error ==> ", error);
      return { message: "Unable to find request", status: false };
    });

  return response.data;
}

export const UpdateWPQHeaderRecord = async (UpdateWPQHeaderRecord) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/UpdateWPQHeaderRecord`;
  const response = await axios
    .post(url, UpdateWPQHeaderRecord)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}